import { TranslateString } from "utils/translateTextHelpers"

export function filterOptions(options: any[], search: string): any[] {
  if (search.length === 0) return options

  const lowerSearchParts = search
    .toLowerCase()
    .split(/\s+/)
    .filter((s) => s.length > 0)

  if (lowerSearchParts.length === 0) {
    return options
  }

  const matchesSearch = (s: string): boolean => {
    const sParts = s
      .toLowerCase()
      .split(/\s+/)
      .filter((str) => str.length > 0)

    return lowerSearchParts.every((p) => p.length === 0 || sParts.some((sp) => sp.startsWith(p) || sp.endsWith(p)))
  }

  return options.filter((o) => {
    // add text id
    if(o.textId){
      const { symbol, name,textId } = o
      const tranName=TranslateString(textId,name)
      return (symbol && matchesSearch(symbol)) || (tranName && matchesSearch(tranName))
    }
    const { symbol, name } = o
    return (symbol && matchesSearch(symbol)) || (name && matchesSearch(name))
  })
}

export default filterOptions
